import React from 'react'

import { Element } from '@Components/Elements/Types'

import styles from './Elements.module.scss'

export const ElementTypography = ({ appearance, htmlElement, style, text }: Extract<Element, { __typename: 'ElementTypography' }>) => {
  const HTMLElement = (htmlElement || 'p') as keyof React.JSX.IntrinsicElements

  return (
    <HTMLElement
      className={styles[style || 'text']}
      style={{
        backgroundColor: appearance?.backgroundColor || undefined,
        color: appearance?.textColor || undefined,
        fontFamily: `var(--font-${appearance?.font || 'gotham'})`,
      }}
    >
      {text}
    </HTMLElement>
  )
}
